// Phase 1A Phase 9C.10c — PhantomTerminalNote premium-rails sibling.
//
// Token-only sibling overlay. Adds the 9C premium chrome vocabulary
// (cardLow elevation, transitionStandard motion, headerLead anchor)
// without expanding the parent file or its co-owned style file.
//
// Trust contract: no raw hex/rgb, no icons here, no emoji, no glow,
// no fake live pulse. Won/busted visual distinction is preserved by
// the parent's terminalCardWon / terminalCardBusted backgrounds.

import type { CSSProperties } from "react";

import { cardLow } from "../../styles/elevation.ts";
import { transitionStandard } from "../../styles/motion.ts";

export const cardRails: CSSProperties = {
  ...cardLow,
  ...transitionStandard,
};

export const headerLead: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sz-space-2)",
  color: "var(--sz-text-secondary)",
};
